var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center px-3 py-2 border-bottom"},[_c('VNameAndAvatar',{attrs:{"name":_vm.project.name,"avatar":_vm.project.icon}}),_c('status-page',{staticClass:"ml-auto",attrs:{"project":_vm.project}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }